import PropTypes from "prop-types";
// @mui
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
// component
import Iconify from "../../components/iconify/Iconify";

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    width: 400,
    boxShadow: theme.customShadows.z8,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

const GoTableSearch = ({ filterName, onSearch, customFilter, openFilter }) => {
  return (
    <StyledRoot
    // sx={{
    //   ...(numSelected > 0 && {
    //     color: "primary.main",
    //     bgcolor: "primary.lighter",
    //   }),
    // }}
    >
      {
        <StyledSearch
          value={filterName}
          onChange={onSearch}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: "text.disabled", width: 15, height: 15 }}
              />
            </InputAdornment>
          }
        />
      }
      {customFilter &&
        <Tooltip title="Filter">
          <IconButton onClick={openFilter}>
            <Iconify icon="ion:filter" />
          </IconButton>
        </Tooltip>
      }
      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <Iconify icon="ic:round-filter-list" />
          </IconButton>
        </Tooltip>
      )} */}
    </StyledRoot>
  );
};

GoTableSearch.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onSearch: PropTypes.func,
};

export default GoTableSearch;
